<template>
  <div
    class="slider slider--theme slider--home"
    :style="{
      '--slider-min-h': slider_height + 'px',
      '--slider-image-h': slider_image_height + 'px',
      '--slider-copy-h': slider_height - slider_image_height + 'px',
    }"
  >
    <div class="slider-primary">
      <div class="container">
        <div class="col-slider" ref="sliderContainer">
          <div>
            <slider-horizontal :data="data" />
          </div>
        </div>
        <div class="col-content col-lg-5">
          <div class="slider-content">
            <h2 v-animate="'slide-up'" class="delay-1">{{ data.title }}</h2>

            <div v-html="data.content" v-animate="'slide-up'" class="delay-2"></div>
            <a
              v-if="data.pagelink && data.pagelinklabel"
              v-animate="'slide-up'"
              class="button button--solid-black delay-3"
              :href="data.pagelink"
              :aria-label="data.pagelinklabel"
              :title="data.pagelinklabel"
              >{{ data.pagelinklabel }}</a
            >
            <a
              v-if="data.secondpagelink && data.secondpagelinklabel"
              v-animate="'slide-up'"
              class="button button--clear-black delay-3"
              :href="data.secondpagelink"
              :aria-label="data.secondpagelinklabel"
              :title="data.secondpagelinklabel"
              >{{ data.secondpagelinklabel }}</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SliderHorizontal } from "../../components";
import { debounce } from "vue-debounce";

const resizeDebounce = debounce((fx) => {
  fx();
}, "250ms");

export default {
  name: "element-slider",
  components: {
    SliderHorizontal,
  },
  props: {
    data: {
      type: Object,
    },
  },
  data() {
    return {
      slider_height: 0,
      slider_image_height: 0,
    };
  },
  created() {
    window.addEventListener("resize", this.resizeHandlerEvent);
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeHandlerEvent);
  },
  mounted() {
    this.resizeHandler();
  },
  methods: {
    resizeHandlerEvent() {
      resizeDebounce(this.resizeHandler);
    },
    resizeHandler() {
      this.slider_height = this.$refs.sliderContainer.offsetHeight;
      this.slider_image_height = this.$refs.sliderContainer.offsetWidth * 67.9 / 100;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../scss/abstracts/variables";
@import "../../../scss/abstracts/mixins";

.slider--home {
  position: relative;
  min-height: auto;
  background-color: $brand-floral-green;

  h1 {
    margin-top: 0;
  }

  @media #{$lg} {
    padding-top: 120px;
    padding-bottom: 120px;
  }

  .container {
    display: block;

    @media #{$lg} {
      min-height: 710px;
      min-height: var(--slider-min-h, 720px);
      display: flex;
    }

    .col-content {
      min-height: auto;
      width: 100%;
      padding: 0 0 7rem 0;
      display: block;
      align-items: center;

      @media #{$lg} {
        // min-height: 100vh;
        width: 45%;
        padding: 0;
        display: flex;
        padding-bottom: var(--slider-copy-h);
      }

      @media (max-width: 767px) {
        padding-bottom: 2rem;
      }

      .slider-content {
        max-width: 530px;
        padding-right: 2rem;

        @media #{$xxl} {
          max-width: 800px;
        }
      }
    }

    .col-slider {
      width: 100%;
      position: relative;
      right: -($outer-container-margin);
      top: -2rem;
      min-height: 400px;
      overflow: hidden;

      @media #{$sm} {
        right: ($grid-gutter-base + $grid-col-base) * (-1);
      }

      @media #{$lg} {
        @include fullgrid-col-width(8);
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        min-height: 550px;
      }

      @media (max-width: 991px) {
        margin-bottom: -2rem;
      }
    }
  }
}
</style>